import type { ModuleFederationManifest } from './types';

let runningPromise: Promise<ModuleFederationManifest>;
/**
 * Fetches the manifest from the release manager
 * It ensures that only one request is made which helps the MF plugin only fetch once
 */
export default async function fetchReleaseManagerManifest(): Promise<ModuleFederationManifest> {
  if (runningPromise) {
    return runningPromise;
  }

  try {
    const adManagerMiddleTierNoAuthHost =
      window?.process?.env?.AD_MANAGER_MIDDLE_TIER_NO_AUTH_HOST || 'https://staging-gcp.api.snapchat.com/ai-releases';
    const promise = fetch(`${adManagerMiddleTierNoAuthHost}/manifest`)
      .then((response) => {
        if (!response.ok) {
          throw Error(`Error fetching manifest: ${response.statusText}`);
        }
        return response.json();
      })
      .then((result) => {
        const data = result as ModuleFederationManifest;
        console.table(data);
        return data;
      })
      .catch((error) => {
        throw Error(`Error fetching manifest: ${error}`);
      });

    runningPromise = promise;
    return runningPromise;
  } catch (error) {
    console.error('Error fetching manifest', error);
    throw error;
  }
}
